export const DAYS = {
    0: 'Monday',
    1: 'Tuesday',
    2: 'Wednesday',
    3: 'Thursday',
    4: 'Friday',
    5: 'Saturday',
    6: 'Sunday'
};

export const STATUS_COLORS = {
    pending: 'orange',
    approved: 'green',
    verified: 'green',
    rejected: 'red',
    active: 'green',
    inactive: 'gray',
    archived: 'gray',
    suspended: 'red',
    completed: 'green',
    canceled: 'red',
    failed: 'red',
    processing: 'yellow',
    in_progress: 'blue',
};

export const COMPETENCY_COLORS = {
    vocabulary: 'orange',
    concept: 'blue',
    application: 'green',
}

export const DISCOUNT_CODES = {
    'TRIAL': 100,
    'SAVE20': 20,
    'WELCOME10': 10,
    'HALFOFF': 50,
};

export const QUIZ_TYPE = {
    class_work:'Class Work',
    trial:'Trial',
    assessment:'Assessment',
    exam:'Exam'
}

export const SUBSCRIPTION_BASE_AMOUNT = 4000; // Base amount in PESEWAS for subscription